"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationTypeEnum = void 0;
var OperationTypeEnum;
(function (OperationTypeEnum) {
    /** Basic Operation Types */
    OperationTypeEnum["FETCH"] = "FETCH";
    OperationTypeEnum["INSERT"] = "INSERT";
    OperationTypeEnum["UPDATE"] = "UPDATE";
    OperationTypeEnum["BULK_UPDATE"] = "BULK_UPDATE";
    OperationTypeEnum["BULK_INSERT"] = "BULK_INSERT";
    OperationTypeEnum["BULK_DELETE"] = "BULK_DELETE";
    OperationTypeEnum["DELETE"] = "DELETE";
    OperationTypeEnum["LOGIN"] = "LOGIN";
    OperationTypeEnum["LOGOUT"] = "LOGOUT";
    OperationTypeEnum["SHARED"] = "SHARED";
    /** User */
    OperationTypeEnum["UPDATE_USER_ROLE"] = "UPDATE_USER_ROLE";
    OperationTypeEnum["INVITE_USER"] = "INVITE_USER";
    /** Expenses */
    OperationTypeEnum["APPROVE_EXPENSE"] = "APPROVE_EXPENSE";
    OperationTypeEnum["DECLINED_EXPENSE"] = "DECLINED_EXPENSE";
    OperationTypeEnum["REVIEWED_EXPENSE"] = "REVIEWED_EXPENSE";
    OperationTypeEnum["PAID_EXPENSE"] = "PAID_EXPENSE";
    OperationTypeEnum["DOCUMENT_EXPENSE"] = "DOCUMENT_EXPENSE";
    OperationTypeEnum["DOCUMENT_NEEDED_EXPENSE"] = "DOCUMENT_NEEDED_EXPENSE";
    OperationTypeEnum["UPDATE_PROFILE_IMG"] = "UPDATE_PROFILE_IMG";
    OperationTypeEnum["INSERT_COMMENT"] = "INSERT_COMMENT";
    OperationTypeEnum["UPDATE_COMMENT"] = "UPDATE_COMMENT";
    OperationTypeEnum["DELETE_COMMENT"] = "DELETE_COMMENT";
    OperationTypeEnum["MENTION_COMMENT"] = "MENTION_COMMENT";
    OperationTypeEnum["UPLOAD_INVOICE_REMINDER"] = "UPLOAD_INVOICE_REMINDER";
    OperationTypeEnum["UPLOAD_DOCUMENT"] = "UPLOAD_DOCUMENT";
    OperationTypeEnum["REMOVE_DOCUMENT"] = "REMOVE_DOCUMENT";
    OperationTypeEnum["APPROVE_REMINDER"] = "APPROVE_REMINDER";
    OperationTypeEnum["BILLED_EXPENSE"] = "BILLED_EXPENSE";
    OperationTypeEnum["DATEV_ONLINE_EXPORT"] = "DATEV_ONLINE_EXPORT";
    OperationTypeEnum["ATTACH_TAG"] = "ATTACH_TAG";
    OperationTypeEnum["DETACH_TAG"] = "DETACH_TAG";
    OperationTypeEnum["DATEV_ONLINE_EXPORT_WRONG_IMPORT_TARGET"] = "DATEV_ONLINE_EXPORT_WRONG_IMPORT_TARGET";
    OperationTypeEnum["DATEV_ONLINE_EXPORT_INVALID_GRANT"] = "DATEV_ONLINE_EXPORT_INVALID_GRANT";
    OperationTypeEnum["DATEV_ONLINE_EXPORT_ERROR"] = "DATEV_ONLINE_EXPORT_ERROR";
    OperationTypeEnum["INVOICE_AUTO_MATCH"] = "INVOICE_AUTO_MATCH";
    OperationTypeEnum["INBOX_ATTACH"] = "INBOX_ATTACH";
    /** Bank Operation types */
    OperationTypeEnum["BANK_WEB_FORM_ABORTED"] = "BANK_WEB_FORM_ABORTED";
    OperationTypeEnum["BANK_IMPORT_SUCCESS"] = "BANK_IMPORT_SUCCESS";
    OperationTypeEnum["BANK_IMPORT_CONFLICT"] = "BANK_IMPORT_CONFLICT";
    OperationTypeEnum["BANK_IMPORT_FAILED"] = "BANK_IMPORT_FAILED";
    OperationTypeEnum["BANK_ADD_INTERFACE_SUCCESS"] = "BANK_ADD_INTERFACE_SUCCESS";
    OperationTypeEnum["BANK_ADD_INTERFACE_FAILED"] = "BANK_ADD_INTERFACE_FAILED";
    OperationTypeEnum["BANK_PAYMENT_SUCCESS"] = "BANK_PAYMENT_SUCCESS";
    OperationTypeEnum["BANK_PAYMENT_IN_PROGRESS"] = "BANK_PAYMENT_IN_PROGRESS";
    OperationTypeEnum["BANK_PAYMENT_FAILED"] = "BANK_PAYMENT_FAILED";
    OperationTypeEnum["BANK_DOWNLOAD_SUCCESS"] = "BANK_DOWNLOAD_SUCCESS";
    OperationTypeEnum["BANK_DOWNLOAD_FAILED"] = "BANK_DOWNLOAD_FAILED";
    /** Credit card Business  */
    OperationTypeEnum["BUSINESS_KYB_ACTION_REQUIRED"] = "BUSINESS_KYB_ACTION_REQUIRED";
    OperationTypeEnum["BUSINESS_KYB_REJECTED"] = "BUSINESS_KYB_REJECTED";
    OperationTypeEnum["BUSINESS_KYB_ACTION_CLOSED"] = "BUSINESS_KYB_CLOSED";
    OperationTypeEnum["BUSINESS_KYB_ACCEPTED"] = "BUSINESS_KYB_ACCEPTED";
    OperationTypeEnum["BUSINESS_TRANSITION"] = "BUSINESS_TRANSITION";
    OperationTypeEnum["USER_TRANSITION"] = "USER_TRANSITION";
    OperationTypeEnum["CARD_TRANSITION"] = "CARD_TRANSITION";
    OperationTypeEnum["TOP_UP_CARD_FAILED"] = "TOP_UP_CARD_FAILED";
    OperationTypeEnum["CARD_UPDATE_PIN"] = "CARD_UPDATE_PIN";
    OperationTypeEnum["UPGRADE_PHYSICAL_CARD_FAILED"] = "UPGRADE_PHYSICAL_CARD_FAILED";
    OperationTypeEnum["EXPENSE_CARD_CREATION_SUCCESS"] = "EXPENSE_CARD_CREATION_SUCCESS";
    OperationTypeEnum["EXPENSE_CARD_CREATION_FAILED"] = "EXPENSE_CARD_CREATION_FAILED";
    OperationTypeEnum["EXPENSE_CARD_TRANSACTION"] = "EXPENSE_CARD_TRANSACTION";
    OperationTypeEnum["CARD_REQUEST_LIMIT_CHANGE"] = "CARD_REQUEST_LIMIT_CHANGE";
    /* Transactions */
    OperationTypeEnum["TRANSACTION_UPDATE_CATEGORY"] = "TRANSACTION_UPDATE_CATEGORY";
    /* Data import */
    OperationTypeEnum["IMPORT_DATA_VALIDATE_ONLY_SUCCESS"] = "IMPORT_DATA_VALIDATE_ONLY_SUCCESS";
    OperationTypeEnum["IMPORT_DATA_VALIDATE_ONLY_FAILURE"] = "IMPORT_DATA_VALIDATE_ONLY_FAILURE";
    OperationTypeEnum["IMPORT_DATA_VALIDATION_ERRORS"] = "IMPORT_DATA_VALIDATION_ERRORS";
    OperationTypeEnum["IMPORT_DATA_SUCCESS"] = "IMPORT_DATA_SUCCESS";
    OperationTypeEnum["IMPORT_DATA_FAILURE"] = "IMPORT_DATA_FAILURE";
    /* Others */
    OperationTypeEnum["ASYNC_EXPORT"] = "ASYNC_EXPORT";
})(OperationTypeEnum = exports.OperationTypeEnum || (exports.OperationTypeEnum = {}));
